import React from "react";
import LegalShell from "./LegalShell";
import { SITE } from "../../data";

export default function AvisoLegal() {
  return (
    <LegalShell title="Aviso Legal" updated="Junio de 2026" path="aviso-legal" description="Aviso legal y datos del titular de España Eficiente (E²).">
      <p>
        En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la
        Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se
        facilita la siguiente información sobre este sitio web.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">1. Titular del sitio</h2>
      <p>
        <strong>Manuel Antonio Evangelista Piris</strong>, con DNI{" "}
        <strong>61094433Q</strong>, es el titular y responsable de{" "}
        <strong>España Eficiente (E²)</strong>, iniciativa independiente de reforma
        política, administrativa y tecnológica, sin ánimo de lucro y sin vinculación
        a ningún partido ni institución.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">2. Contacto</h2>
      <p>
        Puedes ponerte en contacto con nosotros en el correo electrónico{" "}
        <a href={`mailto:${SITE.email}`} className="text-espana-red font-bold">
          {SITE.email}
        </a>{" "}
        o a través del formulario de contacto disponible en la web.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">3. Objeto</h2>
      <p>
        Este sitio tiene una finalidad exclusivamente informativa y divulgativa:
        difundir propuestas, análisis y documentos técnicos (Policy Briefs) sobre
        la reforma y la eficiencia de lo público en España. Los contenidos no
        constituyen asesoramiento profesional de ningún tipo.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">4. Propiedad intelectual</h2>
      <p>
        Los contenidos originales de este sitio (textos, Policy Briefs, diseño y
        elementos gráficos) pertenecen a España Eficiente (E²). Se permite su
        consulta, cita y difusión con fines no comerciales, siempre citando la
        fuente. Queda prohibida su reproducción total o parcial con fines
        comerciales sin autorización.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">5. Responsabilidad</h2>
      <p>
        España Eficiente (E²) no se responsabiliza del uso que terceros puedan
        hacer de la información publicada, ni de los contenidos de sitios externos
        enlazados. Los documentos se basan en fuentes públicas y oficiales que se
        citan en cada caso.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">6. Legislación aplicable</h2>
      <p>
        Las presentes condiciones se rigen por la legislación española. Para
        cualquier controversia serán competentes los juzgados y tribunales que
        correspondan conforme a derecho.
      </p>
    </LegalShell>
  );
}
